module.exports = __webpack_public_path__ + "static/media/server.2dba0da7.png";